import React from "react";
import { UseFormReturn } from "react-hook-form";
import { SwitchSettingWithDescription } from "./SwitchSettingWithDescription";

type DontCompeteWithIgnoreListProps = {
  control: UseFormReturn["control"];
  translate: (_key: string) => string;
};

export const DontCompeteWithIgnoreList: React.FC<
  DontCompeteWithIgnoreListProps
> = ({ control, translate }) => {
  return (
    <SwitchSettingWithDescription
      control={control}
      name="dontCompeteWithCompetitorIgnoreList"
      title={translate("dontCompeteWithIgnoreList")}
      description={translate("dontCompeteWithIgnoreListDescription")}
    />
  );
};
